const getUnit = (value) => {
  if (typeof value === "string") {
    return value;
  }
  return `${value}px`;
};
const calculateOffset = ({ moveBy, placement = "" }) => {
  if (placement.includes("right") || placement.includes("left")) {
    return [moveBy ? moveBy.y : 0, moveBy ? moveBy.x : 0];
  }
  return [moveBy ? moveBy.x : 0, moveBy ? moveBy.y : 0];
};
const resolveWidth = ({
  width,
  minWidth,
  dynamicWidth,
  referenceWidth
}) => {
  return {
    minWidth: dynamicWidth ? `${referenceWidth}px` : getUnit(minWidth),
    width: width || "auto"
  };
};
const createModifiers = ({
  width,
  moveBy,
  appendTo,
  shouldAnimate,
  flip,
  fixed,
  placement,
  isTestEnv,
  minWidth,
  dynamicWidth
}) => {
  const preventOverflow = !fixed;
  const modifiers = [
    {
      name: "offset",
      options: { offset: calculateOffset({ moveBy, placement }) }
    },
    {
      name: "computeStyles",
      enabled: !isTestEnv,
      options: { gpuAcceleration: !shouldAnimate }
    },
    {
      name: "flip",
      enabled: typeof flip !== "undefined" ? flip : !moveBy
    },
    {
      name: "preventOverflow",
      enabled: preventOverflow,
      options: {
        boundariesElement: appendTo || void 0
      }
    },
    {
      name: "hide",
      enabled: preventOverflow
    }
  ];
  if (dynamicWidth || minWidth || width) {
    modifiers.push({
      name: "setPopperWidth",
      enabled: true,
      order: 840,
      fn: (data) => {
        const { width: referenceWidth } = data.offsets.reference;
        data.styles = {
          ...data.styles,
          ...resolveWidth({
            width,
            referenceWidth,
            minWidth,
            dynamicWidth
          })
        };
        return data;
      }
    });
  }
  return modifiers;
};
export {
  createModifiers
};
//# sourceMappingURL=modifiers.js.map
